/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React, {useState, useEffect} from "react";
import ReactDOM from "react-dom/client";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { ThemeProvider } from "@mui/material/styles";
import { store } from "./store";
import reportWebVitals from "./reportWebVitals";
import theme from "./theme";
import { NotificationContextProvider } from "./contexts/notificationContext";
import { CsvExportProvider } from "./contexts/csvExportContext";
import { AbilityProvider } from "./contexts/abilityContext";
import { QueryClientProvider } from "@tanstack/react-query";
import { createQueryClient, setActiveQueryClient } from "./lib/queryClient";
import initHoneycombTelemetry from "./honeycomb_otel"

initHoneycombTelemetry()

function AppRoot() {
  const [queryClient, setQueryClient] = useState(() => {
    const client = createQueryClient();
    setActiveQueryClient(client);
    return client;
  });

  useEffect(() => {
    const handleAuthStateChanged = () => {
      const nextClient = createQueryClient();
      setActiveQueryClient(nextClient);
      setQueryClient(nextClient);
    };
    window.addEventListener("auth-state-changed", handleAuthStateChanged);
    return () => window.removeEventListener("auth-state-changed", handleAuthStateChanged);
  }, []);

  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <AbilityProvider>
          <NotificationContextProvider>
            <QueryClientProvider client={queryClient}>
              <CsvExportProvider>
                <App />
              </CsvExportProvider>
            </QueryClientProvider>
          </NotificationContextProvider>
        </AbilityProvider>
      </ThemeProvider>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<AppRoot />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
